/* this file added by Bearer Web Developer  */
import { useAppState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';
import styles from './information.module.scss';

const Information: React.FC = () => {
    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders.activeManageOrder;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.information} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <ul>
                <li>
                    {
                        theme === 'dark' ? <img src="/person-white.svg" alt="" width={21} height={21} />
                            : <img src="/person-black.webp" alt="" width={21} height={21} />
                    }
                    Recipient’s Name: {activeManageOrder?.recipient_name}
                </li>
                <li>
                    {
                        theme === 'dark' ? <img src="/orders-white.svg" alt="" width={21} height={21} />
                            : <img src="/orders-grey.webp" alt="" width={21} height={21} />
                    }
                    Drop off Method: {activeManageOrder?.dropoff_verification_method}
                </li>
                <li>
                    {
                        theme === 'dark' ? <img src="/call-white.svg" alt="" width={21} height={21} />
                            : <img src="/call-grey.webp" alt="" width={21} height={21} />
                    }
                    Recipient’s Number: {activeManageOrder?.recipient_phone_number}
                </li>
                <li>
                    {
                        theme === 'dark' ? <img src="/weight-white.svg" alt="" width={21} height={21} />
                            : <img src="/weight-grey.webp" alt="" width={21} height={21} />
                    }
                    Parcel Weight: {`${activeManageOrder?.parcel_min_weight} ~ ${activeManageOrder?.parcel_max_weight} KG`}
                </li>
            </ul>
        </div>
    )
}
export default Information;